import { Box, Button, Dialog, DialogContent, Typography } from "@mui/material";
import { BoxFC, BoxFR } from "components/BoxCustom";
import DataGridCellExpand from "components/DataGridCellExpand/DataGridCellExpand";
import { DialogFooter, DialogHeader } from "components/dialog/DialogHeader";
import PaperComponent from "components/PaperComponent";
import { subcontractInvoiceApiNm } from "constants/subcontractConstant";
import { GlobalStateContext } from "contexts/GlobalStateContext";
import dayjs from "dayjs";
import React, { useContext } from "react";
import { useState } from "react";
import { useEffect } from "react";
import { addIdForDataGrid, numberFormat } from "utils";
import {  scPVReportCols } from "./columns";
import { yellow } from '@mui/material/colors';
import PrintRounded from "@mui/icons-material/PrintRounded";
import { useCallback } from "react";
import { printSubcontractPV } from "branch/functions/printSubcontractPV/printSubcontractPV";


const DataBlock = (props) => (
  <BoxFR sx={{ alignItems: "flex-start" }}>
    <Typography variant="body1" sx={{ width: 200, textAlign: "right", verticalAlign: "top" }}><strong>{props.header} : </strong></Typography>
    <Box sx={{ width: 300 }}>{props.children}</Box>
  </BoxFR>
)

let pinnedRows = {
  id: -1,
  ScInvNo: "-",
  ScInvDte: null,
  CusSNm: "-",
  AptTm: null,
  Loc: "-",
  ContNo: "รวม",
  TrnsAmnt: 0,
  OwnRcptAmnt: 0,
  CusRcptAmnt: 0,
  Total: 0,
  WhtPr: 0,
  PayAmnt: 0
}
let normalRows = {
  id: 1,
  ScInvNo: "normal",
  ScInvDte: null,
  CusSNm: "-",
  AptTm: null,
  Loc: "-",
  TrnsAmnt: 0,
  OwnRcptAmnt: 0,
  CusRcptAmnt: 0,
  Total: 0,
  WhtPr: 0,
  PayAmnt: 0
}
const SubcontractPaymentVoucherReportDialog = ({ selectedId, dialogOpen, setDialogOpen }) => {

  const { ax, msData } = useContext(GlobalStateContext)
  const [reportData, setReportData] = useState({
    Sc: {},
    PV: {},
    Exps: [normalRows, pinnedRows]
  })

  const handlePrint = useCallback(() => {
   
    printSubcontractPV({msData: msData, pvData: reportData})
  }, [msData, reportData])
  useEffect(() => {
    if (dialogOpen) {
      ax.post(subcontractInvoiceApiNm.getSubcontractPaymentVoucherReport, { PVId: selectedId }).then(value => {
        if (value.data) {
          const exps = addIdForDataGrid(value.data.Exps, "JobOrdId")
          let sumTrnsAmnt = 0
          let sumOwnRcptAmnt = 0
          let sumCusRcptAmnt = 0
          let sumTotal = 0
          let sumWhtPr = 0
          let sumPayAmnt = 0
          for (const exp of exps) {
            sumTrnsAmnt += + exp.TrnsAmnt
            sumOwnRcptAmnt += +exp.OwnRcptAmnt
            sumCusRcptAmnt += +exp.CusRcptAmnt
            sumTotal += +exp.Total
            sumWhtPr += +exp.WhtPr
            sumPayAmnt += exp.Total - +exp.WhtPr
          }

          pinnedRows.AptTm = null
          pinnedRows.ScInvDte = null
          pinnedRows.TrnsAmnt = sumTrnsAmnt
          pinnedRows.OwnRcptAmnt = sumOwnRcptAmnt
          pinnedRows.CusRcptAmnt = sumCusRcptAmnt
          pinnedRows.Total = sumTotal
          pinnedRows.WhtPr = sumWhtPr
          pinnedRows.PayAmnt = sumPayAmnt

          exps.push(pinnedRows)
          setReportData({ ...value.data, Exps: exps })
          // setDataTable(addIdForDataGrid(value.data.Exps, "JobOrdId"))
        }
      })
    }
  }, [dialogOpen, ax, selectedId])
  return (
    <Dialog
      open={dialogOpen}
      onClose={(e, reason) => {
        if (reason === "backdropClick") return
        setDialogOpen(false)
      }}
      PaperComponent={PaperComponent}
      aria-labelledby="draggable-dialog-title"
      fullWidth maxWidth="xl"
      PaperProps={{
        style: {
          minHeight: '90%',
          maxHeight: '90%',
        }
      }}
    >
      <DialogHeader handleDialogClose={() => setDialogOpen(false)}
        title="รายงานการจ่ายเงินรถร่วม"
        onDeleteClick={null}>
        <Button sx={{ ml: 1 }} variant="contained" color="secondary" onClick={handlePrint}> <PrintRounded sx={{ mr: 1 }} /> พิมพ์</Button>
      </DialogHeader>
      <DialogContent sx={{ display: "flex", gap: 2 }}>
        <BoxFC flex={1} >
          <BoxFR justifyContent="space-around" sx={{ alignItems: "flex-start" }} px={5}>
            <BoxFC mt={2} sx={{ gap: 1 }} width={400}>
              <Typography variant="h5">{reportData.Sc?.Name || "-"}</Typography>
              <Typography >ที่อยู่ {reportData.Sc?.Addr || "-"}</Typography>
              <Typography >เลขประจำตัวผู้เสียภาษี: {reportData.Sc?.TaxId || "-"}</Typography>
              <Typography >โทร. {reportData.Sc?.Tel || "-"}</Typography>
            </BoxFC>
            <BoxFC flex={1} mt={2} sx={{ gap: 0, width: "100%", alignItems: "flex-end" }}>
              <DataBlock header="เลขที่ใบสำคัญจ่าย" >{reportData.PV?.PVNo || "-"}</DataBlock>
              <DataBlock header="วันที่ใบสำคัญจ่าย" >{dayjs(reportData.PV?.PVDte || "-").format("DD/MM/YYYY")}</DataBlock>
              <DataBlock header="จำนวนเงิน" >{numberFormat(+reportData.PV?.PayAmnt || "-")} บาท</DataBlock>
              <DataBlock header="วิธีจ่ายเงิน" >{reportData.PV?.PayMthdNm || "-"}</DataBlock>
              {
                [2, 3].includes(reportData.PV?.PayMthdId || "-") &&
                <DataBlock header="รายละเอียด">
                  {reportData.PV?.PayMthdId  === 2 ?
                    <BoxFC sx={{ gap: 0 }}>
                      <Typography variant="subtitle1">ธนาคาร:{reportData.PV?.ChqBkNm || "-"} สาขา:{reportData.PV?.ChqBrch || "-" }</Typography>
                      <Typography variant="subtitle1">วันที่เช็ค:{dayjs(reportData.PV?.ChqDte || "-").format("DD/MM/YYYY")} เลขที่เช็ค:{reportData.PV?.ChqNo || "-"} </Typography>
                    </BoxFC>
                    : reportData.PV?.PayMthdId  === 3 ?
                    <BoxFC sx={{ gap: 0 }}>
                      <Typography variant="subtitle1">ธนาคาร:{reportData.PV?.TrnBkNm || "-"} สาขา:{reportData.PV?.TrnBkBrch || "-" }</Typography>
                      <Typography variant="subtitle1">วันที่:{reportData?.PV.PayDte ?dayjs(reportData.PV.PayDte ).format("DD/MM/YYYY"): "-"} เลขที่:{reportData.PV?.TrnBkAccNo || "-"} </Typography>
                      <Typography variant="subtitle1">ชื่อบัญขี:{reportData.PV?.TrnAccNm || "-"} </Typography>
                      <Typography variant="subtitle1"></Typography>
                    </BoxFC>
                    :null
                  }
                </DataBlock>
              }
            </BoxFC>
          </BoxFR>

          <Box width='100%' flex={1}
            sx={{
              '& .total': { fontWeight: "bold", bgcolor: yellow[100] },
            }}>
            <DataGridCellExpand
              disableSelectionOnClick
              hideFooter
              rows={reportData.Exps}
              columns={scPVReportCols}
              pinnedRows={{ bottom: [pinnedRows] }}
              experimentalFeatures={{ rowPinning: true }}
              getRowClassName={(params) => params.id === -1 && "total"} />
          </Box>
        </BoxFC>
      </DialogContent>
      <DialogFooter okText="บันทึกข้อมูล"
        handleDialogClose={() => setDialogOpen(false)}
        handleDialogOk={null} />
    </Dialog>
  )
}

export default SubcontractPaymentVoucherReportDialog